import React, { FC } from 'react'
import { Datagrid, Filter, FilterProps, List, ListProps, SearchInput, TextField } from 'react-admin'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'

const ProductTypeFilter: FC<Omit<FilterProps, 'children'>> = (props) => (
  <Filter {...props}>
    <SearchInput source="name" alwaysOn />
  </Filter>
)

const ProductTypeList: FC<ListProps> = (props) => {
  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - Product types`} />
      <RouteBreadcrumbs {...props} />
      <List
        {...props}
        perPage={25}
        sort={{ field: 'name', order: 'ASC' }}
        filters={<ProductTypeFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="edit">
          <TextField source="name" />
        </Datagrid>
      </List>
    </>
  )
}

export default ProductTypeList
